
import axios from 'axios'
import {_handleError,_handleSuccess,_getUrl} from './Handler.js'

export function _login(model){
    // Token: this.$store.getters.token,
    const config = { headers: { 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/authentications`;
    return axios.post(url,model,config).then(_handleSuccess,_handleError)
}
export function _authorize(token){
    // Token: this.$store.getters.token,
    const config = { headers: {'Token':token, 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/authentications`;
    return axios.put(url,{},config).then(_handleSuccess,_handleError)
}